module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v1-500.ef6bed08.png";